<template>
    <el-card class="box-card tip-card">
        <div slot="header" class="clearfix">
            <el-tabs>
                <el-tab-pane :label="introData[path].name"></el-tab-pane>
            </el-tabs>
        </div>
        <el-row :gutter="20">
            <el-col :span="introData[path].layout === 1 ? 18 : 24">
                <div>
                    <div class="title marginT-10 fc-theme fs-18">功能介绍</div>
                    <div>
                        <p v-for="item in introData[path].intro" :key="item">{{item}}</p>
                    </div>
                    <div class="title marginT-10 fc-theme fs-18">使用场景</div>
                    <div>
                        <p v-show="path === '/head_screen/coins'">1、卖家后台需要开通淘金币抵扣，<a style="color: #399cfd;" href="https://login.taobao.com/member/login.jhtml?redirect_url=https%3A%2F%2Fmarket.m.taobao.com%2Fapp%2Ftbcoin%2Fcoin_seller%2Findex.html%23%2Fhome&sub=true" target="_blank">点此</a>开通</p>
                        <p v-for="item in introData[path].used" :key="item">{{item}}</p>
                    </div>
                    <div class="title marginT-10 fc-theme fs-18">注意</div>
                    <div>
                        <p v-for="item in introData[path].notice" :key="item">{{item}}</p>
                        <p style="padding-top: 8px;">接口合作请加微信 {{getkfWx()}}</p>
                    </div>
                </div>
            </el-col>
            <el-col :span="introData[path].layout === 1 ? 6 : 24">
                <p style="font-size: 16px; color: #333; text-align: center; padding: 10px 0;">示例效果图</p>
                <div style="padding: 0 10px;">
                    <img style="width: 100%;" :src="introData[path].exImg" alt="" />
                </div>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>
import {introData} from './introConfig'

export default {
    props: {
        pricePreMonth: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        path() {
            return this.$route.path
        }
    },
    data() {
        return {
            introData,
        }
    },
}
</script>

<style lang="scss" scoped>

</style>
